/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { ApiMessageConfig } from "~/types";

export const resetPasswordApiMessages: ApiMessageConfig = {
  "Invalid token provided": { key: "api.invalid_token", namespace: "forgotPassword" }, // invalid or expired token, reseller not found
  "Account disabled": { key: "api.account_disabled", namespace: "forgotPassword" }, // account disabled
  "Passwords are same": { key: "api.same_password", namespace: "forgotPassword" }, // entered password is the current password
};
